<template>
  <div class="w-100 h-100 d-flex">
    <div
      class="card text-center px-1 py-2 m-auto"
      style="width:25rem;"
    >
      <img
        class="card-img-top py-3 px-5"
        src="../assets/images/logo-aequaroma.jpg"
        alt="AEqua Roma"
      >
      <div class="text-center my-2">
        Servizi per gli utenti del Patrimonio Immobiliare di Roma Capitale
      </div>
      <div class="d-flex flex-column card-body">
        <h2 class="card-title text-uppercase">
          Utente non riconosciuto!
        </h2>
        <h6 class="text-center text-primary mt-3 mb-5 font-weight-bold text-uppercase">
          Vuoi richiedere una accesso come incaricato per una azienda o persona giuridica?
        </h6>
        <p><img src="../assets/images/info.png"></p>
        <a
          class="btn btn-primary btn-lg text-white mt-2"
          @click="logout"
        >
          Torna alla pagine di accesso
        </a>
        <a
          class="btn btn-info btn-lg text-white mt-2"
          @click="richiediConferma"
        >
          Procedi come incaricato
        </a>
      </div>
    </div>
    <richiedi-conferma-modal ref="modal"
      @conferma="goToLanding"
    />
  </div>
</template>

<script>

import RichiediConfermaModal from '@/components/RichiediConfermaModal'

export default {
  components: {
    RichiediConfermaModal
  },
  data () {
    return {
      parameterUri: '',
      messageUnd: this.$router.currentRoute.query.message
    }
  },
  methods: {
    // logout () {
    //   this.$store.dispatch('logout')
    //   this.$router.push({ name: 'login' })
    // },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (err) { }
      // this.$router.push({ name: 'login' })
      this.$router.push({ path: '/entrata' })
    },
    async richiediConferma () {
      this.$refs.modal.open({
        title: 'Accesso incaricato persone giuridiche',
        message: `Per proseguire sono necessari i "Dati identificazione del titolare" della persona giuridica che ha rilasciato l'incarico.\nVuoi proseguire?`,
        okLable: 'Conferma',
        koLabel: 'Annulla'
      })
    },

    async goToLanding (value) {
      // console.log('Conferma value', value)
      if (value.conferma) {
        // OK posso procedere come intermediario
        this.$router.push({ name: 'landing' })
      } else await this.logout()
    }

  }
}
</script>
